import React from 'react';
import { FC } from 'react';
import { getImageBaseURL } from '../../constants';
import { Input, Label, Wrapper } from './Radio.elements';

export interface RadioProps {
    name?: string;
    checked: boolean;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    label?: string;
    isFilterType?: boolean;
    isCircle?: boolean;
    disabled?: boolean;
}

const RadioTemplate: FC<RadioProps> = ({
    name,
    onChange,
    checked,
    children,
    isCircle = false,
    label,
    isFilterType = false,
    disabled = false,
}) => {
    return (
        <Wrapper isCircle={isCircle} isFilterType={isFilterType} disabled={disabled}>
            <Input id={`id-${name}`} onChange={onChange} checked={checked} name={name} type="radio" />
            <Label isBold={isFilterType && checked} htmlFor={`id-${name}`}>
                {children ? children : label}
            </Label>
        </Wrapper>
    );
};

export default RadioTemplate;
